export default {
  name: 'Loader',
  props: {
    what: {
      type: String,
      default: 'data'
    }
  }
};